import { createContext } from 'react';
import { IAccordionVariants, accordionVariants } from './accordion.variants';

export type AccordionGroupContextProps = {
  accordion: boolean;
  index: number;
  variant?: keyof typeof accordionVariants | (string & {});
  variants?: IAccordionVariants;
};

export const AccordionGroupContext = createContext<AccordionGroupContextProps | null>(null);

export const AccordionGroupProvider = AccordionGroupContext.Provider;
